/* Filters, sorting, load-more and the read-more SEO block.
   Every control is a real form control, so this file only adds speed. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_facets']) return;
  window.__hwsLoaded['component_facets'] = true;

  var config = window.hwsSettings || {};

  class HwsFacets extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-facets-form]');
      this.sortForm = this.querySelector('[data-facets-sort]');
      this.resultsSelector = this.dataset.resultsSelector;
      this.sectionId = this.dataset.section;
      this.movePanel();
      if (this.form) {
        this.form.addEventListener('change', this.onFormChange.bind(this));
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        /* De filtervelden staan via het form-attribuut bij dit formulier, maar
           kunnen fysiek in de verplaatste zijkolom zitten. Change-events
           bubbelen dan niet naar het formulier, dus vangen we ze op document
           en checken we of het veld bij dit formulier hoort. */
        var self = this;
        document.addEventListener('change', function (event) {
          var field = event.target;
          if (!field || !field.form || field.form !== self.form) return;
          if (self.form.contains(field)) return;
          self.onFormChange(event);
        });
      }
      if (this.sortForm) {
        var select = this.sortForm.querySelector('[data-facets-sort-select]');
        if (select) select.addEventListener('change', this.onSortChange.bind(this));
      }
      document.addEventListener('click', this.onClick.bind(this));
      /* De eerste geschiedenisregel heeft geen facets-stand, dus deed de terugveeg
         na één filterronde alleen de adresbalk terug en bleef het raster
         gefilterd. Die beginstand leggen we hier vast. */
      if (window.history && window.history.replaceState) {
        window.history.replaceState(
          { facets: window.location.pathname + window.location.search, y: 0 },
          ''
        );
      }
      window.addEventListener('popstate', this.onPopState.bind(this));
      window.addEventListener('resize', this.movePanel.bind(this));
    }

    /* On mobile the same panel lives inside the drawer. */
    movePanel() {
      var panel = this.querySelector('[data-facets-panel]');
      var drawerBody = this.querySelector('[data-facets-drawer-body]');
      var sidebar = document.querySelector('[data-facets-sidebar]');
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (panel) {
        if (isDesktop && sidebar && panel.parentElement !== sidebar) {
          sidebar.appendChild(panel);
        } else if (!isDesktop && drawerBody && panel.parentElement !== drawerBody) {
          drawerBody.appendChild(panel);
        }
      }
      /* De toolbar hoort in de resultatenkolom te staan (handoff), zodat de
         filterkolom op dezelfde hoogte begint als het aantal producten. */
      var toolbar = document.querySelector('[data-facets-toolbar]');
      var slot = document.querySelector('[data-facets-toolbar-slot]');
      if (toolbar && slot && isDesktop && toolbar.parentElement !== slot) {
        slot.appendChild(toolbar);
      }
    }

    rememberOpenGroups() {
      /* Details-stand per groep bewaren zodat filteren niets dichtklapt.
         Het paneel is door movePanel() buiten dit element gezet, dus zoeken op
         document-niveau; binnen het element staat het niet meer. */
      var state = {};
      document.querySelectorAll('details.facets__group').forEach(function (d) {
        var key = d.querySelector('.facets__group-summary');
        if (key) state[key.textContent.trim()] = d.open;
      });
      this._groupState = state;
    }

    restoreOpenGroups() {
      if (!this._groupState) return;
      var state = this._groupState;
      document.querySelectorAll('details.facets__group').forEach(function (d) {
        var key = d.querySelector('.facets__group-summary');
        if (key && Object.prototype.hasOwnProperty.call(state, key.textContent.trim())) {
          d.open = state[key.textContent.trim()];
        }
      });
    }

    onClick(event) {
      var more = event.target.closest('[data-facets-more]');
      if (more) {
        event.preventDefault();
        var group = more.closest('.facets__group-body');
        var hidden = group.querySelectorAll('.facets__value--extra');
        var expanded = more.getAttribute('aria-expanded') === 'true';
        hidden.forEach(function (el) { el.hidden = expanded; });
        more.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var label = more.querySelector('[data-more-text]');
        if (label) {
          var strings = window.hwsStrings || {};
          label.textContent = expanded ? (strings.showMore || label.textContent) : (strings.showLess || label.textContent);
        }
        return;
      }
      /* Een actieve filterchip wegklikken of "wis alle filters" laadde de hele
         pagina opnieuw: je sprong naar boven en op een telefoon klapte de
         filterlade dicht. Dezelfde route als de vinkjes dus. */
      var chip = event.target.closest('[data-facets-active] a[href], a.facets__clear');
      if (chip && chip.getAttribute('href')) {
        event.preventDefault();
        /* Shopify geeft bij url_to_remove soms een volledige URL terug; render()
           plakt er nog een section_id achter en verwacht pad + query. */
        var doel = chip.href.replace(window.location.origin, '');
        this.apply(doel);
        return;
      }

      var view = event.target.closest('[data-view-toggle]');
      if (view) {
        event.preventDefault();
        var mode = view.getAttribute('data-view-toggle');
        var grid = document.querySelector('[data-product-grid]');
        if (grid) grid.classList.toggle('product-grid--list', mode === 'list');
        this.querySelectorAll('[data-view-toggle]').forEach(function (el) {
          el.classList.toggle('is-active', el === view);
        });
      }
    }

    onFormChange() {
      window.clearTimeout(this.timer);
      var self = this;
      this.timer = window.setTimeout(function () { self.apply(); }, 320);
    }

    onSubmit(event) {
      if (!window.fetch) return;
      event.preventDefault();
      this.apply();
    }

    onSortChange() {
      this.apply();
    }

    buildUrl() {
      var params = new URLSearchParams();
      /* Het sorteerformulier eerst: daar zitten de verborgen velden in die de
         context vasthouden (op de zoekpagina de zoekterm q). Stond er geen
         filterformulier — een zoekopdracht zonder filters — dan viel die
         zoekterm weg en kwam je na het sorteren op een lege pagina. */
      if (this.sortForm) {
        new FormData(this.sortForm).forEach(function (value, key) {
          if (value !== '' && key !== 'sort_by') params.append(key, value);
        });
      }
      if (this.form) {
        new FormData(this.form).forEach(function (value, key) {
          if (value === '' || key === 'sort_by') return;
          if (params.getAll(key).indexOf(value) !== -1) return;
          params.append(key, value);
        });
      }
      var sortSelect = this.sortForm && this.sortForm.querySelector('[data-facets-sort-select]');
      if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);
      var qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    apply(url) {
      this.rememberOpenGroups();
      var doel = url || this.buildUrl();
      this.setLoading(true);
      if (window.history.scrollRestoration) {
        window.history.scrollRestoration = 'manual';
      }
      /* De scrollpositie vasthouden. Zonder dit springt de pagina wanneer de
         nieuwe set korter is dan de oude en het document daardoor inklapt. */
      this._scroll = window.scrollY;
      window.history.pushState({ facets: doel, y: this._scroll }, '', doel);
      this.render(doel);
    }

    onPopState(event) {
      if (!event.state || !event.state.facets) return;
      this._scroll = event.state.y;
      this.render(window.location.pathname + window.location.search);
    }

    /* Tijdens het laden komen er lege kaarten in de plaats van de resultaten, in
       hetzelfde aantal als er nu staat. Zonder dat gebeurde er visueel niets
       tussen de klik en het antwoord, en leek het filter kapot. */
    setLoading(state) {
      var results = document.querySelector(this.resultsSelector);
      if (!results) return;
      results.setAttribute('aria-busy', state ? 'true' : 'false');
      var grid = results.querySelector('[data-product-grid]');
      if (!grid) return;
      if (!state) {
        grid.classList.remove('product-grid--loading');
        return;
      }
      var aantal = Math.min(grid.children.length || 6, 12);
      grid.classList.add('product-grid--loading');
      var html = '';
      for (var i = 0; i < aantal; i += 1) {
        html +=
          '<li class="product-grid__item product-grid__item--skeleton" aria-hidden="true">' +
          '<span class="card-skeleton"><span class="card-skeleton__media hws-skeleton"></span>' +
          '<span class="card-skeleton__line hws-skeleton"></span>' +
          '<span class="card-skeleton__line card-skeleton__line--short hws-skeleton"></span></span></li>';
      }
      grid.innerHTML = html;
    }

    render(url) {
      var self = this;
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + separator + 'section_id=' + this.sectionId)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var newResults = parsed.querySelector(self.resultsSelector);
          var results = document.querySelector(self.resultsSelector);

          /* movePanel() zet de toolbar (sorteren, aantal, filterknop,
             raster/lijst) op desktop ín de resultatenkolom. Die kolom wordt
             hieronder in zijn geheel vervangen, dus verdween de toolbar bij de
             eerste filterronde uit de pagina en werkte sorteren daarna niet
             meer. We halen hem er daarom eerst uit en zetten hem terug in de
             nieuwe slot; zo blijven ook de gekozen sortering en de listeners
             staan. */
          var toolbar = document.querySelector('[data-facets-toolbar]');
          var toolbarUitResultaten = !!(toolbar && results && results.contains(toolbar));
          if (toolbarUitResultaten) toolbar.remove();

          if (newResults && results) results.innerHTML = newResults.innerHTML;

          if (toolbarUitResultaten) {
            var slot = results.querySelector('[data-facets-toolbar-slot]');
            if (slot) slot.appendChild(toolbar);
            else results.insertBefore(toolbar, results.firstChild);
          }

          /* De teller op de mobiele filterknop stond niet in de lijst met
             elementen die werden bijgewerkt; hij bleef dus op de stand van de
             vorige ronde staan. */
          var badge = document.querySelector('[data-facets-filter-count]');
          var newBadge = parsed.querySelector('[data-facets-filter-count]');
          if (badge) {
            var badgeTekst = newBadge ? newBadge.textContent.trim() : '';
            badge.textContent = badgeTekst;
            badge.hidden = badgeTekst === '' || badgeTekst === '0';
          }

          var newFacets = parsed.querySelector('hws-facets');
          if (newFacets) {
            var active = self.querySelector('[data-facets-active]');
            var newActive = newFacets.querySelector('[data-facets-active]');
            if (active && newActive) { active.innerHTML = newActive.innerHTML; }
            else if (newActive && !active) { self.insertBefore(newActive, self.querySelector('[data-facets-form]')); }
            else if (active && !newActive) { active.remove(); }
            /* Het aantal staat op meerdere plekken (toolbar én de kop van de
               zoekpagina). Alle exemplaren op de pagina bijwerken, niet alleen
               die binnen dit element. */
            var countSource = newFacets.querySelector('[data-facets-count]');
            if (countSource) {
              document.querySelectorAll('[data-facets-count]').forEach(function (el) {
                el.textContent = countSource.textContent;
              });
            }

            /* Het filterpaneel zelf werd nooit vervangen: aantallen per waarde en
               het uitgeschakeld-zijn van waarden zonder resultaat bleven van de
               vorige stand staan. Het paneel staat na movePanel() buiten dit
               element, dus zoeken we het in het document. */
            var panel = document.querySelector('[data-facets-panel]');
            var newPanel = newFacets.querySelector('[data-facets-panel]');
            /* Typt iemand net in een prijsveld, dan zou het vervangen van het
               paneel de focus en de cursor weggooien: je kon niet van "Van" naar
               "Tot" tabben. In dat geval laten we het paneel met rust; de
               aantallen kloppen dan één ronde later. */
            var bezig = panel && document.activeElement && panel.contains(document.activeElement);
            if (panel && newPanel && !bezig) {
              if (self.rememberOpenGroups) self.rememberOpenGroups();
              panel.innerHTML = newPanel.innerHTML;
            }
          }
          if (window.hwsReveal) window.hwsReveal.scan();
          if (self.restoreOpenGroups) self.restoreOpenGroups();
          if (window.hwsDeliveryPromise) window.hwsDeliveryPromise();
          if (typeof self._scroll === 'number') {
            window.scrollTo(0, self._scroll);
            self._scroll = null;
          }
          if (window.hwsAnnounce) {
            var count = document.querySelector('[data-facets-count]');
            if (count) window.hwsAnnounce(count.textContent.trim());
          }
        })
        .catch(function () {
          /* Ging de aanvraag mis, dan stonden er voorgoed lege shimmerkaarten:
             setLoading(true) had het raster al vervangen. De pagina opnieuw laden
             is hier het eerlijkste — de stand staat al in de adresbalk. */
          window.location.assign(url);
        })
        .finally(function () {
          self.setLoading(false);
          /* Terugzetten, anders landt de bezoeker na een filterronde bovenaan de
             collectie in plaats van bij de kaart waar hij vandaan kwam. */
          if (window.history.scrollRestoration) {
            window.history.scrollRestoration = 'auto';
          }
        });
    }
  }
  if (!customElements.get('hws-facets')) customElements.define('hws-facets', HwsFacets);

  /* Load more */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-load-more]');
    if (!button || !window.fetch) return;
    event.preventDefault();
    button.classList.add('btn--loading');
    fetch(button.getAttribute('href'))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var items = parsed.querySelectorAll('[data-product-grid] > li');
        var grid = document.querySelector('[data-product-grid]');
        if (grid) items.forEach(function (item) { grid.appendChild(item); });
        var nextButton = parsed.querySelector('[data-load-more]');
        if (nextButton) { button.setAttribute('href', nextButton.getAttribute('href')); }
        else { button.remove(); }
        /* De pagina in de adresbalk bijwerken. Zonder dit kwam je na terug- of
           doorsturen, of met een gedeelde link, weer op pagina 1 terwijl je al
           een eind verder was. */
        if (window.history && window.history.replaceState) {
          var geladen = new URL(button.getAttribute('href') || window.location.href, window.location.origin);
          var volgende = parseInt(geladen.searchParams.get('page'), 10);
          var nu = new URL(window.location.href);
          if (volgende > 1) {
            nu.searchParams.set('page', String(volgende - 1));
          } else {
            nu.searchParams.delete('page');
          }
          window.history.replaceState(window.history.state, '', nu.pathname + nu.search);
        }
        if (window.hwsReveal) window.hwsReveal.scan();
        if (window.hwsDeliveryPromise) window.hwsDeliveryPromise();
      })
      .finally(function () { button.classList.remove('btn--loading'); });
  });

  /* Read more on the SEO block */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-read-more-toggle]');
    if (!toggle) return;
    var content = toggle.previousElementSibling;
    if (!content) return;
    var open = content.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var strings = window.hwsStrings || {};
    toggle.textContent = open ? (strings.readLess || toggle.textContent) : (strings.readMore || toggle.textContent);
  });

})();
